import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Person } from "../../../../utils/backend-types";
import { ObjectName } from "../../../../utils/enums";
import type { GasConnectionResponse } from "../../../GasConnectionWizard/GasConnection.types";
import { ComponentOpenEditModalLink } from "../../ComponentOpenEditModalLink/ComponentOpenEditModalLink";

interface GetGasConnectionCustomColumnsProps {
  persons?: Array<Person>;
  projectId: string;
  siteId: number;
}

function getGasConnectionCustomColumns({
  persons,
  projectId,
  siteId
}: GetGasConnectionCustomColumnsProps): Array<
  MRT_ColumnDef<GasConnectionResponse>
> {
  return [
    {
      header: "Netzanschlussnehmer",
      accessorFn: (rowData) =>
        persons?.find((person) => person.id === rowData.connecting_party)
          ?.name || rowData.connecting_party,
      Cell: ({ cell, row }) => {
        const connectingParty = row.original.connecting_party;
        return (
          connectingParty && (
            <ComponentOpenEditModalLink
              componentId={connectingParty}
              linkContent={cell.getValue<string | number>()}
              objectName={ObjectName.Person}
              projectId={projectId}
              siteId={siteId}
            />
          )
        );
      }
    }
  ];
}

export { getGasConnectionCustomColumns };
